import axios from "@/plugins/axios";

let url = "/api/console/platforms/barocon";

export const barocon = {
    get(data){
        return axios.get(url, data).then(result => result.data);
    },
}